import React, { useState, ChangeEvent, FC, useEffect } from 'react';
import { useTranslate } from '../../../hooks/LanguageProvider';

interface AbsenceOfTransmissionProps {
  alarm: any; // Adapter le type en fonction de votre structure d'alarme
  onChange: (newMetrics: any) => void; // Fonction de rappel pour mettre à jour l'état du composant parent
}

const AbsenceOfTransmission: FC<AbsenceOfTransmissionProps> = ({ alarm, onChange }) => {
  const [absence, setAbsence] = useState<string>("48");
  const { translate } = useTranslate();
  const quickValues = [
    { label: "15 min", value: "0.25" },
    { label: "30 min", value: "0.5" },
    { label: "1 h", value: "1" },
    { label: "24 h", value: "24" },
  ];

  useEffect(() => {  
   // console.log("alarm", alarm);
    if (alarm !== "") {  
      setAbsence(alarm.hours);
    } else {
      setAbsence("48");
    }
  }, [alarm]);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    checkText(event.target); // Appel de la fonction checkText 
    setAbsence(value);
    onChange({ ...alarm, type:"AbsenceOfTransmission", hours: value });
  };

  const handleQuickValue = (value: string) => {
    setAbsence(value);
    onChange({ ...alarm, type:"AbsenceOfTransmission", hours: value });
  };

  const handleQuickValueChange = (event: ChangeEvent<HTMLSelectElement>) => {
    handleQuickValue(event.target.value);
  };

  const checkText = (input: HTMLInputElement) => {
    // Logique de la fonction checkText
   // console.log('Text checked:', input.value);
  };
 
  return (
    <div className="d-flex align-items-center flex-wrap" style={{ gap: "8px" }}>
      <div className="input-group input-group-sm" style={{ width: "360px" }}>
        <span className="input-group-text">{translate("Maximum duration")}</span>
        <input
          className="form-control"
          name="no_transmision"
          value={absence}
          placeholder='Absence de transmission'
          type="number"
          min="0"
          step="0.25"
          size={10}
          maxLength={20}
          onChange={handleInputChange}
        />
        <span className="input-group-text">h</span>
      </div>
      <select
        className="form-select form-select-sm"
        style={{ width: "120px" }}
        value={absence}
        onChange={handleQuickValueChange}
      >
        {quickValues.map((item) => (
          <option
            key={item.value}
            value={item.value}
          >
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default AbsenceOfTransmission;
